<script setup lang="ts">
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { useMission } from "@/stores/mission";
import { onMounted, ref } from "vue";
import { DispatchType, MateDispatchStatusRequest } from "@/enums/mission";
import { ApiGetMateDispatchPage } from "@/apis/dispatchMission";
import { MateDispatch } from "@/types/entity";
import { useMate } from "@/stores/mate";

const missionStore = useMission();

const props = defineProps<{
  mateId: number;
  status: MateDispatchStatusRequest;
  include?: number[];
  isSelect?: boolean;
}>();

const mateStore = useMate();
const mateId = ref<number | undefined>(props.mateId);
const showOcSelector = ref(false);

const emit = defineEmits<{
  (e: "select", item: MateDispatch): void;
}>();

const threadListRef = ref<ThreadListInstance>();
const list = ref<number[]>([]);

const reload = async () => {
  list.value = [];
  threadListRef.value?.resetScrollLoadingState();
};

const loadNextPageData = async () => {
  const { length } = list.value;
  const page = length / 20 + 1;
  if (length !== 0 && length % 20 !== 0) return false;

  const res = await ApiGetMateDispatchPage({
    filter: {
      status: props.status,
      mateId: mateId.value ?? mateStore.userMate.id,
      type: DispatchType.Mission,
    },
    pagination: { page, perPage: 20 },
    sort: { field: "dtUpdate", order: "desc" },
  });
  if (page === 1) list.value.length = 0;

  list.value.push(
    ...res.page.data.map((item) => {
      missionStore.mateDispatchMap[item.id] = item;
      return item.id;
    })
  );

  return res.page.data.length === 20;
};

const onConfirmOc = (_mateId?: number) => {
  mateId.value = _mateId;
  reload();
};

onMounted(() => {
  reload();
});
</script>

<template>
  <ThreadList
    ref="threadListRef"
    :on-pull-load="() => reload()"
    :on-scroll-load="() => loadNextPageData()"
  >
    <div class="flex items-center justify-between m-1">
      <SelectAllMate
        :active-mate-id="mateId"
        v-model:show="showOcSelector"
        @confirm="onConfirmOc"
      />
      <!-- <TimeSort :sort="activeSort" @update:sort="onSorterChange" /> -->
    </div>
    <div class="py-4 flex flex-col gap-1 pr-2">
      <MissionListItem
        v-for="mateDispatchId in list"
        :key="mateDispatchId"
        :item="missionStore.getDispatchById(mateDispatchId)"
        :is-select="isSelect"
        :include="include"
        @select="emit('select', missionStore.getDispatchById(mateDispatchId))"
      />
    </div>
  </ThreadList>
</template>
